import React, { useState, useEffect } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import SideMenuDetails from './SideMenuDetails';
import { validatePrivilege } from '../../../helpers/adminPrivileges';
import s from './SideMenuSection.css';

function SideMenuSection({ handleMobileMenu, menuData, label, location, isSuperAdmin, privileges, isPromoCodeEnabled, isServicePlanEnabled }) {
    const [pathName, setPathName] = useState(null);

    useEffect(() => {
        setPathName(location);
    }, [location]);

    // Determine if we should show the label (based on privilege or super admin flag)
    const showLabel = menuData?.some(item => {
        if (item?.isValidatePrivilege) {
            return validatePrivilege(item?.privilegeId, privileges || [], isSuperAdmin);
        }
        return item?.isSuperAdmin ? isSuperAdmin : true;
    });

    return (
        <>
            {label && showLabel && (
                <div className={s.sideMenuGroupCaption}>
                    <span className={s.sideMenuGroupCaptionText}>{label}</span>
                </div>
            )}

            {menuData?.map((item, key) => {
                let isMenuActive = false;
                // Check if any activePath is a prefix of the current location
                if (item?.activePaths?.length > 0 && pathName) {
                    isMenuActive = item.activePaths.some(path => pathName.startsWith(path));
                }

                const hasAccess = item?.isValidatePrivilege
                    ? validatePrivilege(item?.privilegeId, privileges || [], isSuperAdmin)
                    : item?.isSuperAdmin
                        ? isSuperAdmin
                        : true;
                if (item?.label === 'manageCouponCode') {
                    if (!hasAccess || isPromoCodeEnabled !== 'true') return null;
                } if (item?.label == 'servicePlanLabel') {
                    if (!hasAccess || isServicePlanEnabled !== 'true') return null;
                } else {
                    if (!hasAccess) return null;
                }


                return (
                    <div key={key}>
                        <SideMenuDetails
                            data={item}
                            keyValue={key}
                            location={pathName}
                            handleMobileMenu={handleMobileMenu}
                            isMenuActive={isMenuActive}
                        />
                    </div>
                );
            })}
        </>
    );
}


export default withStyles(s)(SideMenuSection);
